<template>
  <div class="progress">
    <div class="progress-status" v-if="showLabel && !showWave">
      当前进度：{{ rowData.schedule }}
      <count-down
        v-if="iconShow && rowData.status === 0 && rowData.over_time"
        :key="rowData.over_time"
        :startTime="getNowTime"
        :endTime="rowData.over_time"
        class="count-down"
        @timeChange="(val) => (time = val)"
        @countDownChange="timeEnd"
      >
        <template>
          <img class="clock" src="@/assets/image/bargin/clock.png" alt="" />
          <span class="label">{{ time }}</span>
        </template>
      </count-down>
    </div>
    <div
      :class="[
        'progress-current',
        rowData.status <= 1 ? 'current-active' : 'current-negative',
      ]"
    >
      <div
        :style="{
          width: porgressWidth,
        }"
        :class="[
          'progress-inner',
          rowData.status <= 1 ? 'inner-active' : 'inner-negative',
        ]"
      >
        <div class="circle circle-1"></div>
        <div class="circle circle-2"></div>
        <div class="circle circle-3"></div>
        <div class="circle circle-4"></div>
      </div>
      <template v-if="showWave">
        <div
          class="move-bar"
          :style="{
            left:wavePosition
          }"
        ></div>
        <div
          class="move-bar delay-1"
          :style="{
            left:wavePosition,
          }"
        ></div>
        <div
          class="move-bar delay-2"
          :style="{
            left: wavePosition,
          }"
        ></div>
      </template>
    </div>
    <div class="progress-label">
      <div
        v-for="(item, index) in rowData.step_list"
        :key="item"
        :class="[
          'progress-label-item',
          index <= rowData.step ? 'label-active' : 'label-negative',
          rowData.status <= 1 ? 'in-process' : 'in-cancel',
        ]"
      >
        <bargainPublicity v-if="item.indexOf('人')>=0" :contentText="item" :number="rowData.number" :detailsData="rowData.new_bargain_list"></bargainPublicity>
        <template v-else>
          {{ item }}
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import countDown from "@/components/countDown";
import bargainPublicity from "@/components/bargainPublicity"
export default {
  components: {
    countDown,
    bargainPublicity
  },
  props: {
    rowData: {
      type: Object,
      default: () => ({}),
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    showWave: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      time: "",
      iconShow: true,
    };
  },
  computed: {
    getNowTime() {
      return new Date().getTime() / 1000;
    },
    porgressWidth() {
      var stepLength = Object.keys(this.rowData.step_list) .length
      return  this.rowData.step <= 2
              ? 'calc(' + (this.rowData.step - 0 + 1) / stepLength + ' * 100% - 100%/12)'
              : this.rowData.step < 4
              ? 'calc(' + (this.rowData.step) / stepLength + ' * 100% - 100%/48)'
              : this.rowData.step < 5
              ? 'calc(' + (this.rowData.step) / stepLength + ' * 100% - 100%/24)'
              : '100%'
    },
    wavePosition() {
      var stepLength = Object.keys(this.rowData.step_list) .length
      return  this.rowData.step <= 2
              ? 'calc(' + (this.rowData.step - 0 + 1) / stepLength + ' * 100% - 100%/12 - 5px )'
              : this.rowData.step < 4
              ? 'calc(' + (this.rowData.step) / stepLength + ' * 100% - 100%/48 - 5px )'
              : this.rowData.step < 5
              ? 'calc(' + (this.rowData.step) / stepLength + ' * 100% - 100%/24 - 5px )'
              : '100%'
    }
  },
  methods: {
    timeEnd(e, val) {
      this.iconShow = false;
      this.$emit("payOverTime", this.rowData.id);
    },
  },
};
</script>

<style lang="less" scoped>
.progress {
  font-family: PingFang SC-Regular, PingFang SC;
  width: 390px;
  height: 46px;
  &-status {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    display: flex;
    align-items: center;
    .count-down {
      display: flex;
      align-items: center;
      margin-left: 10px;
      .clock {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
      .label {
        font-weight: 400;
        color: var(--primary, #FF5A1F);
      }
    }
  }
  &-current {
    width: 100%;
    height: 7px;
    position: relative;
    border-radius: 4px;
    margin: 5px 0;
    overflow: hidden;
    &.current-active {
      background: #fff3e3;
    }
    &.current-negative {
      background: #ebf2f7;
    }
    .progress-inner {
      height: 100%;
      width: 0;
      position: absolute;
      left: 0;
      top: 0;
      border-radius: 4px;
      transition: all ease-out 0.3s;
      .circle {
        position: absolute;
        width: 3px;
        height: 3px;
        border-radius: 50%;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        z-index: 3;
        @set: {
          one: 1;
          two: 0.5;
          three: 0.3;
          four: 0.1;
        };
        each(@set, {
            &.circle-@{index} {
              right: ((@index - 1) * 4 + 2px ) ;
              background:rgba(255, 255, 255, @value);
            };
        });
      }
      &.inner-active {
        background: linear-gradient(270deg, var(--primary, #FF5A1F) 0%, var(--primary-soft, #FCEDE5) 100%);
      }
      &.inner-negative {
        background: linear-gradient(270deg, #5A5F6B 0%, #d7dfe5 100%);
      }
    }
    @keyframes bar-move {
      0% {
        width: 0;
        opacity: 1;
      }
      100% {
        width: 95px;
        opacity: 0;
      }
    }
    .move-bar {
      position: absolute;
      height: 7px;
      width: 0px;
      background: var(--primary, #FF5A1F);
      border-radius: 4px;
      z-index: 2;
      animation: bar-move 1.5s linear infinite;
      &.delay-1 {
        animation-delay: 0.5s;
      }
      &.delay-2 {
        animation-delay: 1s;
      }
    }
  }
  &-label {
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    &-item {
      // width: calc(100%/6);
      text-align: center;
      font-size: 12px;
      font-weight: 300;
      line-height: 12px;

      &.label-active {
        color: var(--primary, #FF5A1F);
      }
      &.label-negative {
        color: #e2cab3;
      }
      &.in-cancel.label-active {
        color: #5A5F6B;
      }
      &.in-cancel.label-negative {
        color: #c0c6cc;
      }
    }
  }
}
</style>